import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.SAMA_GLOBAL_LIST}`,
            render: () => import("../../Pages/Nursing/SelfAdministrationOfMedicationAssessment/List/SamaList.svelte"),
            title: "Self-Administration of Medication Assessments"
        }
    ]
};

export default routerConfig;
